import { IPagerParams } from '../baseType';

export interface IMessageQueryParams extends IPagerParams {
  userId: string;
  /**
   * 已读状态：0-未读，1-已读
   */
  readStatus?: string;
  messageId?: string;
  /**
   * 客户端列表中最旧的一条消息id，查询此消息之前的的消息
   */
  oldestMessageIdInClient?: string;
  /**
   * 客户端最新的一条消息id，查询此消息之后的消息
   */
  latestMessageIdInClient?: string;
}

export interface ISysMessage {
  /** 创建人，消息发送人 */
  createBy: string;
  createTime: Date;
  /** 消息发送人名称 */
  senderName: string;
  /** 消息发送人头像 */
  senderAvatar: string;
  updateBy: string;
  updateTime: Date;
  id: string;
  type: string;
  typeName: string;
  status: string;
  statusName: string;
  applicantId: string;
  applicantName: string;
  recipientId: string;
  title: string;
  content: string;
  readTime: Date;
  readStatus: string;
}

/**
 * @description 获取消息列表
 *
 * @param {IMessageQueryParams} data
 */
export function getMessagePageList(data: IMessageQueryParams) {
  return request({
    url: '/sysMessage',
    method: 'get',
    params: data,
  });
}

/**
 * 获取未读消息数
 * @returns 未读消息数
 */
export function getUnReadCount() {
  return request({
    url: '/sysMessage/unReadCount',
    method: 'get',
  });
}

/**
 * 标记所有未读消息为已读
 */
export function allMarkRead() {
  return request({
    url: '/sysMessage/allMarkRead',
    method: 'get',
  });
}

/**
 * 标记未读消息为已读
 */
export function markRead(messageId: string) {
  return request({
    url: `/sysMessage/markRead/${messageId}`,
    method: 'get',
  });
}
